// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
// import { env } from './.env';

export const environment = {
  production: false,
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US'],
  version: '1.0',
  serverUrl: '/api',

  serverKey:
    'AAAAVYP57nE:APA91bE_R1tobYRKFjd1S_fSWWFZFQPwbv0tGB7tsqDeyyNpkH5PukDfs1gtApfgPAv0Kf_BM2zR0-qAi1HHxY4B79-ztcEFR7-ajTVUzpCI48AtLHy5p13af-SvFREcaSP0ic-cR_F9',
  firebaseConfig: {
    databaseURL: 'https://isha-dev-1c475.firebaseio.com',
    apiKey: 'AIzaSyCqmjvgk_c-pApMhfgZgdFIHVRjkpxcyEg',
    authDomain: 'isha-dev-1c475.firebaseapp.com',
    projectId: 'isha-dev-1c475',
    storageBucket: 'isha-dev-1c475.appspot.com',
    messagingSenderId: '367286414961',
    appId: '1:367286414961:web:2fc411296e959a50a735d0',
    measurementId: 'G-0MLTWTCV2N',
  },
};
